import { MenuItem } from '@mui/material'
import { useState } from 'react'
import {
  type CreateCollectionPopoverDto,
  NewNodePopover_CreatingCollection,
} from './NewNodePopover_CreatingCollection.tsx'

export type NewNodePopoverItem = 'Collection' | 'Folder'
export type NewNodePopoverResult =
  | { item: 'Collection'; data: CreateCollectionPopoverDto }
  | { item: 'Folder'; data: undefined }

export interface CollectionsNewPopoverItemsProps {
  onItemSelected: (result: NewNodePopoverResult) => void
}

enum NewNodePopoverState {
  Initial,
  CreatingCollection,
}

export function NewNodePopoverItems({ onItemSelected }: CollectionsNewPopoverItemsProps) {
  const [state, setState] = useState<NewNodePopoverState>(NewNodePopoverState.Initial)

  if (state === NewNodePopoverState.CreatingCollection) {
    return (
      <NewNodePopover_CreatingCollection
        onItemSelected={(result) => {
          onItemSelected({
            item: 'Collection',
            data: result,
          })
        }}
      />
    )
  }

  return (
    <>
      <MenuItem
        onClick={() => {
          setState(NewNodePopoverState.CreatingCollection)
          // onItemSelected('Collection')
        }}
      >
        Collection
      </MenuItem>
      <MenuItem
        onClick={() => {
          onItemSelected({
            item: 'Folder',
            data: undefined,
          })
        }}
      >
        Folder
      </MenuItem>
    </>
  )
}
